module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_mp3player_3d8c610ec3408cdcfe699cbabb547148.png";